import { CUSTOM_GROUP_NAMES, TABLE_ACTIONS } from "./types";
import { ResourceEventData } from "./types/interfaces";
import { useSignalREvent } from "./useSignalREvent";
import { useSignalRGroups } from "./useSignalRGroups";

export const useSignalRForNotifications = (
    userId: number | undefined,
    callback: (data: ResourceEventData) => void
) => {
    const isUserIdDefined = userId !== undefined;

    const eventName = isUserIdDefined
        ? `_${TABLE_ACTIONS.Creating}`
        : undefined;

    const groups = isUserIdDefined
        ? [`${CUSTOM_GROUP_NAMES.User}.${userId}`]
        : [];

    useSignalREvent<ResourceEventData>(eventName, data => callback(data));
    useSignalRGroups(groups);
};
